import type { ReactNode } from "react"

import type { YasalBelge } from "../types"
import { YasalBelgeIcerik } from "./yasal-belge-icerik"

interface YasalBelgeSayfasiProps {
  belge: YasalBelge
  /** Belgenin üstünde, yazdırmada gizlenen alan (açıklama, yazdır butonu). */
  ust?: ReactNode
}

export function YasalBelgeSayfasi({ belge, ust }: YasalBelgeSayfasiProps) {
  return (
    <main
      id="public-content"
      tabIndex={-1}
      className="mx-auto w-full max-w-3xl flex-1 px-4 py-10 sm:px-6 sm:py-14 print:max-w-none print:p-0"
    >
      {ust && <div className="mb-6 print:hidden">{ust}</div>}
      <div className="rounded-lg border bg-white p-5 sm:p-10 print:rounded-none print:border-0 print:p-0">
        <YasalBelgeIcerik belge={belge} />
      </div>
    </main>
  )
}
